<ng-container *ngIf="!professional">
  <span class="profile-avatar">
    <div *kzImgPlaceholder="false;showProfile:true;"></div>
  </span>
  <div>
    <div style="display: flex; align-items: center; max-width: 80%;">
      <kz-text-placeholder nbLines="1" [biggerFirstLine]="size !== 'xs'"></kz-text-placeholder>
      <span kzBadge badgeType="pro" [badgePlaceholder]="'shimmer'" style="margin-left: 1rem; margin-bottom: 0.3rem;"></span>
    </div>
    <kz-text-placeholder [nbLines]="(size === 'xs' || size === 'sm') ? 1 : 2" biggerFirstLine="false"></kz-text-placeholder>
  </div>

</ng-container>
<ng-container *ngIf="professional">
  <span class="profile-avatar">
    <a [routerLink]="professional | proLink" *ngIf="linkToPro">
      <ng-container *ngTemplateOutlet="avatar"></ng-container>
    </a>
    <ng-container  *ngIf="!linkToPro">
      <ng-container *ngTemplateOutlet="avatar"></ng-container>
    </ng-container>
    <ng-template #avatar>
      <app-picture-source [imgSrc]="professional | getUserOrProProperty : 'avatar'"
                          [alt]="professional | getUserOrProProperty : 'username'"
                          [presets]="presetUserAvatar"
                          [width]="imgSize"
                          [height]="imgSize"
                          imgFit="true"
                          useWebp="true"
                          useLazyLoad="true"
                          handleX2="true"
      ></app-picture-source>
    </ng-template>
  </span>
  <div *ngIf="(professional | getPro : 'mainJob' | async) as proMainJob">
    <p>
      <span class="infos-name">
        <ng-container *ngIf="size !== 'lg'">
          <span class="infos-brand" *ngIf="!linkToPro">{{ professional.brand }}</span>
          <a [routerLink]="professional | proLink" class="infos-brand" *ngIf="linkToPro">{{ professional.brand }}</a>
        </ng-container>
        <ng-container *ngIf="size === 'lg'">
          <h1 class="infos-brand" *ngIf="!linkToPro">{{ professional.brand }}</h1>
        </ng-container>
        <span class="infos-badges">
          <span kzBadge badgeType="pro"  i18n="@@pro.header.badge.pro">Pro</span>
          <kz-icons
            *ngIf="professional.isCertified"
            name="certified"
            [kzTooltip]="tooltipTpl"
            tooltipPosition="top-left"></kz-icons>
        </span>
      </span>
      <span style="display: none">{{proMainJob.mainJob}}</span>
      <span class="infos-activity" *ngIf="proMainJob.mainJob">{{proMainJob.mainJob | proJobName}}
        <ng-container *ngIf="proMainJob.city">- {{proMainJob.city}} </ng-container>
      </span>
    </p>
    <ng-template #tooltipTpl>
      <div style="padding: .5rem" i18n="@@pro.header.tooltip.pro.certified">This professional has been contacted by Kozikaza and the existence of the company verified.</div>
    </ng-template>
    <div class="infos-additional">
      <div *ngIf="size !== 'xs' && size !== 'sm'" class="infos-tags">

          <span kzTag [tagContext]="professional.isBoxable ? 'box' : 'decorator'"
                             *ngFor="let style of professional.styles | slice:0:limitStyles; trackBy: trackById;">
            <ng-container *ngIf="(style | getProfessionalStyle | async) as styleRessource">{{styleRessource.name}}</ng-container>
          </span>
          <ng-container *ngIf="professional.styles.length > limitStyles && seeMore">
            <a *ngIf="seeMoreLink" [routerLink]="professional | proLink" kzTag tagContext="more">. . .</a>
            <span *ngIf="!seeMoreLink" (click)="showMore.emit(true)" kzTag tagContext="more">. . .</span>
          </ng-container>

      </div>
    </div>
  </div>
</ng-container>
